import { render } from "./PoliticasMascotas.vue?vue&type=template&id=349df17e"
import script from "./PoliticasMascotas.vue?vue&type=script&lang=js"
export * from "./PoliticasMascotas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__